export const initiateLogin = async ({ email, language, apiUrl }) => fetch(`${apiUrl}/v1/accounts/v2/initiate`, {
  method: 'post',
  headers: {
    'Content-Type': 'application/json',
  },
  body: JSON.stringify({ email, language }),
});

export const getPersonalCounter = async ({ token, apiUrl }) => fetch(`${apiUrl}/v1/user-impact-gateway/personal_counter?token=${token}`)
  .then((response) => response.json())
  .catch((error) => ({
    error,
  }));

export const refreshToken = async ({ token, apiUrl }) => fetch(`${apiUrl}/v1/accounts/v2/refresh_token`,
  {
    body: JSON.stringify({
      token,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
  },
)
  .then((response) => response.json())
  .catch((error) => ({
    error,
  }));
